import React from 'react';
import { format, parseISO } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { Calendar } from '../components/ui/calendar';

// Format any ISO date string (or Date) as UK dd/mm/yyyy. Returns '' when empty.
export const fmtUK = (value, withTime = false) => {
  if (!value) return '';
  try {
    const d = typeof value === 'string' ? parseISO(value) : value;
    return format(d, withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy');
  } catch { return ''; }
};

const toISO = (d) => (d ? format(d, 'yyyy-MM-dd') : '');

// UK-style date picker. `value` is an ISO 'yyyy-MM-dd' string; `onChange` receives the same.
export const UKDatePicker = ({ value, onChange, testId, placeholder = 'dd/mm/yyyy', disabled, min }) => {
  const [open, setOpen] = React.useState(false);
  const selected = value ? parseISO(value) : undefined;
  const minDate = min ? parseISO(min) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          data-testid={testId}
          className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 text-left text-sm text-gray-700 outline-none transition-colors focus:border-[#3a9b5c] focus:ring-2 focus:ring-[#3a9b5c]/20 disabled:opacity-60"
        >
          <span className={value ? '' : 'text-gray-400'}>{value ? fmtUK(value) : placeholder}</span>
          <CalendarIcon size={16} className="text-[#3a9b5c]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          disabled={minDate ? { before: minDate } : undefined}
          onSelect={(d) => { onChange(toISO(d)); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default UKDatePicker;
